import React from 'react';
import { useSelector } from 'react-redux';
import { Content, Title, Text, Consent, Actions, Button } from './commonStyles';
import Links from '~/compositions/TermsAndPolicy/Links';
import { VRPAT } from '~/config/constants';

type TAttention = {
  onBack: () => void;
  onReminder: () => void;
};

export default function AreYouSure({
  onBack,
  onReminder,
}: TAttention): JSX.Element {
  // @ts-ignore
  const issuer = useSelector(state => state?.issuer?.name);
  const btnStyle = issuer === VRPAT ? 'institutional' : 'caixa';
  return (
    <Content>
      <Title>Atenção</Title>
      <Text>
        Para a segurança das suas informações e continuar aproveitando nossas
        dicas e novidades sobre o seu benefício, é preciso aceitar os novos{' '}
        <Links /> da VR Benefícios.
      </Text>
      <Consent>
        <Actions>
          {/* @ts-ignore */}
          <Button
            fullWidth
            ariaLabel="Voltar"
            label="Voltar"
            variant="contained"
            onClick={() => onBack()}
            color={btnStyle}
          />
          {/* @ts-ignore */}
          <Button
            fullWidth
            ariaLabel="Ok, entendi"
            label="Ok, entendi"
            variant="contained"
            onClick={() => onReminder()}
            color={btnStyle}
          />
        </Actions>
      </Consent>
    </Content>
  );
}
